<template>
  <v-layout align-center column>
    <p class="Text-Hero">
      Kuasai 10 Keterampilan Ini Agar Dibutuhkan di Pasar Kerja Masa Depan
    </p>
    <v-row>
      <span class="Penulis">Fadhel Yafie</span
      ><span class="Date">Feb 26, 2021</span>
    </v-row>
    <v-row>
      <div class="Shape"><p class="Category">Ekonomi</p></div>
      <div class="Shape"><p class="Category">Tech & Bisnis</p></div>
    </v-row>
    <img
      src="../assets/BlogDetail/Blog-Image.png"
      srcset="
        ../assets/BlogDetail/Blog-Image@2x.png 2x,
        ../assets/BlogDetail/Blog-Image@3x.png 3x
      "
      class="Blog-Image"
    />
     
    <v-row>
   <div style="width: 28px;position:relative;top:30px;right: 10px;" >
          <img
            src="../assets/BlogDetail/Twitter.png"
            srcset="
              ../assets/BlogDetail/Twitter@2x.png 2x,
              ../assets/BlogDetail/Twitter@3x.png 3x
            "
            class="Twitter"
          />

          <img
            src="../assets/BlogDetail/Facebook.png"
            srcset="
              ../assets/BlogDetail/Facebook@2x.png 2x,
              ../assets/BlogDetail/Facebook@3x.png 3x
            "
            class="Facebook"
          />

          <img
            src="../assets/BlogDetail/Instagram.png"
            srcset="
              ../assets/BlogDetail/Instagram@2x.png 2x,
              ../assets/BlogDetail/Instagram@3x.png 3x
            "
            class="Instagram"
          />
        </div>
      <v-col >
        <p class="sub-title" v-bind:style="{'margin-right': socialMarginRight}">
          Kuasai 10 Keterampilan Ini Agar Dibutuhkan di Pasar Kerja Masa Depan
        </p>
      </v-col>
    </v-row>

    <p class="Desc">
      Kita sudah sering kali mendengar berita tentang era disrupsi atau revolusi
      4.0. Saking populernya wacana ini, istilah revolusi 4.0 bahkan dijadikan
      bahan perdebatan calon presiden pada 2019 silam. Peradaban manusia sedang
      bergerak dengan sangat cepat berkat perkembangan teknologi. Saat ini kita
      sedang di ambang revolusi 4.0. Disadari atau tidak, dampak revolusi 4.0
      sudah terasa pada hari ini. Perkembangan teknologi, khususnya dalam
      kemampuan komputasi digital dan pengolahan big data mendisrupsi nya ris
      seluruh aspek kehidupan manusia. Nah, salah satu yang cukup terdampak
      dengan revolusi 4.0 ini adalah pasar kerja. Para ahli memprediksi akan
      banyak sekali jenis pekerjaan yang hilang dan digantikan oleh kecerdasan
      buatan dan mesin otomatis. Contoh yang paling mudah adalah disrupsi
      transportasi yang dulu dikuasai oleh taksi dan ojek pangkalan. Hari ini,
      ojek pangkalan nyaris punah digantikan oleh ojek online. Sebentar lagi,
      kalau teknologi mobil dan motor otomatis sudah diprediksi secara massal,
      bukan tidak mungkin profesi supir akan menyusul kepunahan ojek pangkalan.
    </p>
    <img
      src="../assets/BlogDetail/content/Blog-Image.png"
      srcset="
        ../assets/BlogDetail/content/Blog-Image@2x.png 2x,
        ../assets/BlogDetail/content/Blog-Image@3x.png 3x
      "
      class="Blog-Image-1"
    />
    <p class="sub-title">Keterampilan yang dibutuhkan di Masa Depan</p>
    <p class="Desc">
      Menurut laporan
      <span class="text-style-1">Future of Jobs dari World Economic Forum</span
      >, lebih dari sepertiga keterampilan yang dibutuhkan hari ini tidak lagi
      relevan dalam lima tahun yang akan datang. Oleh karena itu, tidak ada
      waktu lagi untuk Sobat Kilat bertahan dalam zona nyaman pekerjaan. Ini
      adalah waktu yang tepat untuk mengembangkan keterampilan baru agar tetap
      relevan di masa depan. Berikut beberapa keterampilan yang menurut ahli
      dari World Economic Forum akan dibutuhkan di masa depan:
    </p>
    <p class="sub-title-1">1. Keterampilan untuk Belajar Hal Baru</p>
    <p class="Desc">
      Karena kecepatan perubahan di tempat kerja di masa depan, pekerja harus
      belajar dengan cepat dan mampu bersahabat dengan perubahan. Otak kita
      tidak hanya harus fleksibel, tetapi kita juga harus bisa beradaptasi
      karena kita harus menyesuaikan diri dengan perubahan tempat kerja,
      ekspektasi, dan keahlian.
    </p>
    <div class="Shape-quote">
      <p class="double">”</p>
      <p class="Quote">
        “Keterampilan penting selama revolusi industri 4.0 adalah kemampuan
        untuk mempelajari hal baru dan terbuka terhadap perubahan sebagai
        peluang untuk tumbuh dan berinovasi”
      </p>
    </div>
    <p class="Desc">
      Pengetahuan yang dipelajari saat sekolah dulu kemungkinan besar tidak lagi
      relevan saat memasuki pasar kerja. Hal ini dikarenakan perkembangan
      teknologi yang sedemikian cepat. Kecerdasan buatan dan machine learning
      mampu membuat mesin menggantikan pekerjaan-pekerjaan manusia yang monoton
      dan terlalu mekanis.
    </p>
    <p class="sub-title-1">2. Keterampilan Teknologi</p>
    <v-row>
      <img
        src="../assets/BlogDetail/content/1/Blog-Image.png"
        srcset="
          ../assets/BlogDetail/content/1/Blog-Image@2x.png 2x,
          ../assets/BlogDetail/content/1/Blog-Image@3x.png 3x
        "
        class="Small-Blog-Image"
      />

      <img
        src="../assets/BlogDetail/content/2/Blog-Image.png"
        srcset="
          ../assets/BlogDetail/content/2/Blog-Image@2x.png 2x,
          ../assets/BlogDetail/content/2/Blog-Image@3x.png 3x
        "
        class="Small-Blog-Image"
      />
    </v-row>
    <p class="Desc">
      Seperti yang sudah ditulis di awal, revolusi industri 4.0 didorong oleh
      inovasi teknologi seperti kecerdasan buatan, big data, virtual reality,
      blockchain, dan teknologi-teknologi canggih lainnya. Artinya, setiap orang
      dan perusahaan akan membutuhkan banyak sekali tenaga kerja yang ahli dalam
      mengoperasikan teknologi baru ini. Pada tingkat paling dasar, hampir
      seluruh karyawan di industri apapun harus memiliki pemahaman dasar untuk
      menggunakan teknologi. Ditambah lagi dengan pandemi COVID-19, semua bidang
      industri mau tidak mau harus memanfaatkan teknologi untuk mengatasi
      masalah yang disebabkan pandemi seperti work from home yang membuat
      masalah komunikasi tidak se-luwes saat bekerja di kantor.
    </p>
    <p class="Desc">
      Penetrasi teknologi yang luar biasa besar saat ini membuat banyak
      perusahaan harus memanfaatkan berbagai macam teknologi untuk dapat
      bersaing di masa depan. Hari ini, perusahaan-perusahaan terbesar di dunia
      adalah mereka yang bergerak di bidang teknologi komputasi. Sebut saja
      Amazon, Tesla, Apple, Google, Microsoft, Facebook dan lain sebagainya.
      Jadi, kalau kamu ingin tetap relevan dan memiliki peluang besar untuk
      dipekerjakan di pasar kerja, cara terbaik untuk mencapainya adalah
      memiliki keterampilan di bidang teknologi.
    </p>
    <p class="Related-Article">Related Article</p>

    <div style="width:1100px;">
      <v-row v-bind:style="{ margin: `0 auto 0 auto` }">
        <blog-card v-for="data in blogs" :key="data" :data="data" />
      </v-row>
    </div>
    <!-- <div>
      <div style="width: 28px;position:absolute;top:26%;" v-bind:style="{'left': socialMarginLeft}">
        <img
          src="../assets/BlogDetail/Twitter.png"
          srcset="
            ../assets/BlogDetail/Twitter@2x.png 2x,
            ../assets/BlogDetail/Twitter@3x.png 3x
          "
          class="Twitter"
        />

        <img
          src="../assets/BlogDetail/Facebook.png"
          srcset="../assets/BlogDetail/Facebook@2x.png 2x, ../assets/BlogDetail/Facebook@3x.png 3x"
          class="Facebook"
        />

        <img
          src="../assets/BlogDetail/Instagram.png"
          srcset="../assets/BlogDetail/Instagram@2x.png 2x, ../assets/BlogDetail/Instagram@3x.png 3x"
          class="Instagram"
        />
      </div>
    </div> -->
  </v-layout>
</template>
<script>
import BlogCard from "../components/BlogList/BlogCard.vue";
export default {
  components: { BlogCard },
  data() {
    return {
      heroTextSize: `48px`,
      marginLeft: `${window.innerWidth / 8}px`,
      socialMarginRight: `${window.innerWidth / 8}px`,
      marginTop: `${window.innerWidth / 6}px`,
      width: `${window.innerWidth / 4}px`,
      fontSize: `40px`,
      blogs: [
        {
          image: require("../assets/BlogList/1/Blog-Image.png"),
          title: "Resensi Kilat: Rich Dad Poor Dad karangan Robert Kiyosaki",
          author: "Fadhel Yafie",
          date: "Feb 27, 2021",
          desc:
            "Saat liburan sekolah, Jimmy mengundang banyak temannya ke resort mewah milik orang tuanya. Hanya ada dua orang yang tidak diundang...",
          category: "Literasi Finansial",
          subCategory: "Tips Keuangan",
        },
        {
          image: require("../assets/BlogList/2/Blog-Image.png"),
          title:
            "Ingin Investasi Saham? Pelajari Dulu Penjelasan tentang Saham!",
          author: "Fadhel Yafie",
          date: "Feb 18, 2021",
          desc:
            "Halo Sobat Kilat! Sadar gak kalau belakangan ini banyak banget orang yang ngomongin saham? Gak sedikit juga yang mulai coba-coba...",
          category: "Ekonomi",
          subCategory: "Literasi Finansial",
        },
        {
          image: require("../assets/BlogList/3/Blog-Image.png"),
          title: "Mungkinkah Kecerdasan Buatan Menggantikan Pekerjaan Manusia?",
          author: "Fadhel Yafie",
          date: "Feb 26, 2021",
          desc:
            "Kecepatan perkembangan teknologi sedang dalam tahap yang paling cepat sepanjang sejarah. Sobat Kilat bisa membayangkan 10 tahun...",
          category: "Ekonomi",
          subCategory: "Tech & Bisnis",
        },
      ],
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.marginLeft = `${window.innerWidth / 8}px`;
      this.marginTop = `${window.innerWidth / 7}px`;
      this.width = `${window.innerWidth / 3}px`;
      this.fontSize = `${window.innerWidth / 40}px`;
      this.socialMarginRight = `${window.innerWidth / 60}px`;
      
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
};
</script>
<style scoped>
.Text-Hero {
  width: 1048px;
  height: 112px;
  margin: 69px auto 24px auto;
  font-family: Sora;
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
  position: relative;
}
.Penulis {
  width: 95px;
  height: 22px;
  flex-grow: 0;
  margin: 0 24px 14px 0;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Date {
  width: 99px;
  height: 22px;
  flex-grow: 0;
  margin: 0 0 14px 0;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: right;
  color: #767676;
}
.Shape {
  /* width: 80px; */
  /* width: 105px; */

  height: 27px;

  flex-grow: 0;

  margin: 0 0 0 8px;

  padding: 6px 14px;

  border-radius: 13.5px;

  border: solid 1.4px #b5b5b5;

  background-color: var(--white);
}
.Category {
  /* width: 77px; */

  height: 15px;

  flex-grow: 0;

  font-family: Inter;

  font-size: 12px;

  font-weight: 600;

  font-stretch: normal;

  font-style: normal;

  line-height: normal;

  letter-spacing: normal;

  text-align: center;

  color: #b5b5b5;
}
.Blog-Image {
  width: 1600px;
  height: 700px;
  margin: 16px 0 32px;
  object-fit: contain;
}
.Blog-Image-1 {
  width: 1048px;
  height: 450px;
  margin: 32px auto 32px auto;
  object-fit: contain;
}
.sub-title {
  width: 1040px;
  /* height: 90px; */
  margin: 5px auto 16px auto;
  font-family: Sora;
  font-size: 36px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1.8px;
  text-align: left;
  color: #252525;
}
.Desc {
  width: 1048px;
  /* height: 240px; */
  margin: 16px auto 0 auto;
  font-family: Inter;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: justify;
  color: #252525;
}
.Desc .text-style-1 {
  font-weight: bold;

  color: #000000;
}
.double {
  width: 35px;
  height: 51px;
  flex-grow: 0;
  margin: 0 353px 0px 354px;
  font-family: Sora;
  font-size: 72px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: justify;
  color: #767676;
}
.Shape-quote {
  width: 895px;
  height: 171px;
  flex-grow: 0;
  margin: 32px auto 32px auto;
  padding: 6px 77px 28px 76px;
  opacity: 0.5;
  background-color: #f1f1f1;
}
.Quote {
  width: 742px;
  height: 78px;
  flex-grow: 0;
  /* margin: 0 0 0; */
  font-family: Inter;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: italic;
  line-height: 1.3;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.sub-title-1 {
  width: 1048px;
  height: 23px;
  margin: 32px 0 16px 0 ;
  font-family: Sora;
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.9px;
  text-align: left;
  color: #252525;
}
.Small-Blog-Image {
  width: 514px;
  height: 350px;
  margin: 16px 20px 16px 42px;
  object-fit: contain;
}
.Related-Article {
  width: 183px;
  height: 30px;
  flex-grow: 0;
  margin: 100px 100px 30px 99px;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.24px;
  text-align: center;
  color: #252525;
}

.Related-Article .text-style-1 {
  letter-spacing: normal;
}

.Twitter {
  width: 34px;
  height: 35.1px;
  /* margin: 32px 42px 8px 200px; */
  object-fit: contain;
}
.Instagram {
  width: 34px;
  height: 35.1px;
  /* margin: 8px 42px 256.8px 200px; */
  object-fit: contain;
}
.Facebook {
  width: 34px;
  height: 35.1px;
  /* margin: 8px 42px 8px 200px; */
  object-fit: contain;
}
</style>
